/**
 * Google Analytics utility functions
 */

// Define the gtag function as it's loaded from the script in index.html
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Initialize Google Analytics
 * This function is called once when the app loads
 */
export const initialize = () => {
  // Google Analytics is already initialized via the script in index.html
  // This function is mainly for tracking the initial page load
  if (typeof window.gtag === 'function') {
    pageview(window.location.pathname, document.title);
  } else {
    console.warn('Google Analytics not loaded');
  }
};

/**
 * Track a page view in Google Analytics
 * @param page_path The path of the page to track
 * @param page_title Optional page title
 */
export const pageview = (page_path: string, page_title?: string) => {
  if (typeof window.gtag !== 'function') {
    console.warn('Google Analytics not loaded');
    return;
  }
  
  window.gtag('config', 'G-77FYW9KXZ3', {
    page_path,
    page_title
  });
};

/**
 * Track an event in Google Analytics
 * @param action The action name
 * @param params Additional event parameters
 */
export const event = (action: string, params: Record<string, any> = {}) => {
  if (typeof window.gtag !== 'function') {
    console.warn('Google Analytics not loaded');
    return;
  }
  
  window.gtag('event', action, params);
};

/**
 * Track user login event
 * @param method Login method used (e.g., 'email', 'google')
 */
export const trackLogin = (method: string) => {
  event('login', { method });
};

/**
 * Track user signup event
 * @param method Signup method used
 */
export const trackSignup = (method: string) => {
  event('sign_up', { method });
};

/**
 * Track conversation events
 * @param action The conversation action (e.g., 'message_sent', 'response_received')
 * @param params Additional parameters
 */
export const trackConversation = (action: string, params: Record<string, any> = {}) => {
  event(`conversation_${action}`, params);
};
